// @ts-nocheck
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import CardViewIcon from '@material-ui/icons/ViewStream';
import ListViewIcon from '@material-ui/icons/ViewList';
import TabletIcon from '@material-ui/icons/Tablet';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import qs from 'qs';
import React from 'react';
import { connect } from 'react-redux';
import HypertouchDeviceDetails from '../components/HypertouchDevices/HypertouchDeviceDetails.jsx';
import HypertouchDevicesListView from '../components/HypertouchDevices/HypertouchDevicesListView.jsx';
import HypertouchDevicesTableView from '../components/HypertouchDevices/HypertouchDevicesTableView.jsx';
import OperationalView from '../components/OperationalView/OperationalView.jsx';
import PresentationalViewHeader from '../components/PresentationalView/PresentationalViewHeader.jsx';
import { VIEW_MODES } from '../_config/consts';
import { saveDataToLocalStorage } from '../_config/utils';
import * as GatewaysActions from '../redux/actions/gateways.actions';
import * as UtilsActions from '../redux/actions/utils.actions';

let filterTimeout;

@connect(state => ({
  gateways: state.gateways,
  routing: state.router,
  viewLoading: state.utils.viewLoading,
  themeName: state.settings.items.theme.data.themeName,
}))
class HypertouchDevicesView extends React.Component {
  constructor(props) {
    super(props);
    const cachedViewMode = localStorage.getItem('hypertouchDevicesViewMode');
    this.state = {
      searchText: '',
      activeTab: cachedViewMode && cachedViewMode === VIEW_MODES.CARDS ? 1 : 0,
    };
  }

  componentWillMount() {
    const { dispatch, routing } = this.props;
    dispatch(GatewaysActions.setSelectedHyperTouchDevice({}));
    dispatch(GatewaysActions.setHyperTouchDevicesOperationalMode(false));

    const parsed = qs.parse(routing.location.search, { ignoreQueryPrefix: true });
    this.fetchDevices(parsed.serial);
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(GatewaysActions.setSelectedHyperTouchDevice({}));
    dispatch(GatewaysActions.setHyperTouchDevicesOperationalMode(false));
  }

  async fetchDevices(selectSerial) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setViewLoading(true));
    try {
      const devices = await dispatch(GatewaysActions.fetchHyperTouchDevices());
      if (selectSerial) {
        const device = _.find(devices, d => d.serial === selectSerial);
        if (device) {
          this.onSelectDevice(device);
        }
      }
    } finally {
      dispatch(UtilsActions.setViewLoading(false));
    }
  }

  getFilteredDevices() {
    const hyperTouch = this.getHyperTouchState();
    const { devices } = hyperTouch;
    const { searchText } = this.state;
    if (!searchText) return devices;

    return _.filter(devices, device => {
      const name = (device.deviceName || '').toLowerCase();
      const serial = (device.serial || '').toLowerCase();
      return name.includes(searchText) || serial.includes(searchText);
    });
  }

  onFilterDevices(value) {
    const formattedValue = value && _.trim(value).toLowerCase();
    if (filterTimeout) clearTimeout(filterTimeout);
    filterTimeout = setTimeout(() => {
      this.setState({ searchText: formattedValue });
    }, 300);
  }

  onSelectDevice(device) {
    const { dispatch } = this.props;
    dispatch(GatewaysActions.setSelectedHyperTouchDevice(device));
    dispatch(GatewaysActions.setHyperTouchDevicesOperationalMode(true));
  }

  closeOperationalSection() {
    const { dispatch } = this.props;
    dispatch(GatewaysActions.setHyperTouchDevicesOperationalMode(false));
    dispatch(GatewaysActions.setSelectedHyperTouchDevice({}));
  }

  onViewModeChange(activeTab) {
    const selectedViewMode = activeTab === 0 ? VIEW_MODES.TABLE : VIEW_MODES.CARDS;
    this.setState({ activeTab });
    saveDataToLocalStorage('hypertouchDevicesViewMode', selectedViewMode);
  }

  getHyperTouchState() {
    const { gateways } = this.props;
    return (gateways && gateways.hyperTouch) || { devices: [], selectedDevice: {}, isOperationalMode: false };
  }

  render() {
    const { activeTab } = this.state;
    const { devices, selectedDevice, isOperationalMode } = this.getHyperTouchState();
    const { themeName, viewLoading } = this.props;
    const filteredDevices = this.getFilteredDevices();
    const numberOfDevices = devices ? devices.length : 0;
    const hasDevices = !_.isEmpty(filteredDevices);
    const listTop = hasDevices ? 190 : 140;

    return (
      <div>
        <PresentationalViewHeader
          themeName={themeName}
          onFilterChange={value => this.onFilterDevices(value)}
          onSearchReset={() => this.setState({ searchText: '' })}
          onRefresh={() => this.fetchDevices()}
          isLoading={viewLoading}
          numberOfElements={numberOfDevices}
          searchPlaceholderEntityName="hypertouchDevices"
          entitiesNumberSection={
            <div style={{ marginRight: 20, marginTop: 13, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <TabletIcon style={{ fontSize: 22 }} />
              <h4 style={{ marginTop: 0 }}>{numberOfDevices}</h4>
            </div>
          }
        />
        {hasDevices ? (
          <div className="r-flow-on-phone" style={{ top: 140, position: 'fixed', backgroundColor: 'white' }}>
            <Tabs
              value={activeTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={(e, index) => this.onViewModeChange(index)}
              TabIndicatorProps={{
                style: { display: 'none' },
              }}
            >
              <Tab icon={<ListViewIcon style={{ fontSize: 30 }} />} />
              <Tab icon={<CardViewIcon style={{ fontSize: 30 }} />} />
            </Tabs>
          </div>
        ) : null}
        {activeTab === 0 ? (
          <HypertouchDevicesTableView
            devices={filteredDevices}
            totalDevicesCount={numberOfDevices}
            viewLoading={viewLoading}
            selectedDevice={selectedDevice}
            onSelectDevice={device => this.onSelectDevice(device)}
            onRefresh={() => this.fetchDevices()}
            listTop={listTop}
          />
        ) : null}
        {activeTab === 1 ? (
          <HypertouchDevicesListView
            devices={filteredDevices}
            totalDevicesCount={numberOfDevices}
            viewLoading={viewLoading}
            selectedDevice={selectedDevice}
            onSelectDevice={device => this.onSelectDevice(device)}
            listContainerStyle={{ top: listTop }}
          />
        ) : null}
        <OperationalView
          themeName={themeName}
          isVisible={isOperationalMode}
          onClose={() => this.closeOperationalSection()}
          onRefresh={() => this.fetchDevices()}
          title={selectedDevice && selectedDevice.deviceName ? selectedDevice.deviceName : <Entity entity="hypertouchDeviceDetails" />}
        >
          <HypertouchDeviceDetails device={selectedDevice} />
        </OperationalView>
      </div>
    );
  }
}

export default HypertouchDevicesView;
